import * as angular from 'angular';
import * as uiDropdown from 'angular-ui-bootstrap/src/dropdown';

import { rubricModule } from '../rubric';
import { richDropdownModule } from '../rich-dropdown';
import { rubricSessionModel } from '../models/rubric-session';
import { rubricTemplateModel } from '../models/rubric-template';
import { groupDepModel } from '../models/group-dep';
import { goStorageModule } from '../go-storage';
import { confirmModalModule } from '../modals/confirm';
import { ngxGoPrintServiceModule } from '@go-modules/services/go-print';
import { ngxZeroStateModule } from '@go-modules/components/zero-state';
import { ngxActiveBrandServiceModule } from '@go-modules/services/active-brand';
import { ngxUserServiceModule } from '@go-modules/services/user';

import { rubricFeedbackViewerComponent } from './rubric-feedback-viewer.component';
import { rubricGradeTotalsBarComponent } from './rubric-grade-totals-bar/rubric-grade-totals-bar.component';
import { ngxRubricFilterDropdown } from '@go-modules/components/feedback-session/feedback-filters/rubric-filter';
import { ngxRubricServiceModule } from '@go-modules/services/rubric';
import { ngxFeatureFlagServiceModule } from '@go-modules/services/feature-flag';

import './style.less';

export const rubricFeedbackViewerModule = angular.module('rubric-feedback-viewer', [
	richDropdownModule,
	rubricModule,
	rubricSessionModel,
	rubricTemplateModel,
	uiDropdown,
	groupDepModel,
	goStorageModule,
	confirmModalModule,
	ngxGoPrintServiceModule,
	ngxRubricFilterDropdown,
	ngxZeroStateModule,
	ngxActiveBrandServiceModule,
	ngxRubricServiceModule,
	ngxFeatureFlagServiceModule,
	ngxUserServiceModule
])
	.component('rubricFeedbackViewer', rubricFeedbackViewerComponent)
	.component('rubricGradeTotalsBar', rubricGradeTotalsBarComponent)
	.name;
